
import { defineComponent, Ref, ref } from "vue";
import FilterSlide from "./FilterSlide.vue";
import FilterCheck from "./FilterCheck.vue";
import { FilterCheckData } from "@/types";
import {mapGetters} from "vuex";

export default defineComponent({
    name: "FilterSection",
    components: {
        FilterSlide,
        FilterCheck,
    },
    computed: mapGetters({
        showLessLabel: 'getShowLessLabel',
        showMoreLabel: 'getShowMoreLabel'
    }),
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const controlType = props.section.type === 'slide' ? FilterSlide : FilterCheck,
            visibleCount: Ref<number> = ref(5);

        let allVisible: Ref<boolean> = ref(false);

        const toggleVisibility = (): void => {
            allVisible.value = !allVisible.value;
        };

        const getHiddenCount = (): number => {
            return props.section.data.filter((check: FilterCheckData, index: number) => {
                return index >= visibleCount.value && !check.checked;
            }).length;
        }

        return {
            controlType,
            visibleCount,
            allVisible,
            toggleVisibility,
            getHiddenCount
        }
    }
});
